import {Space} from "antd";
import {CreateSessionFormStepsMobile} from "../../create-session-steps";
import {useCreateSessionContext} from "../../context/create-session";
import {CreateSessionBasicFormStep} from "../basic-form";
import {CreateSessionCheckoutFormStep} from "../checkout-form";
import {ServiceFormLayout} from "../../service-form-layout";
import {StyledHideStepOnDesktop} from "../../../../../components/offering-form/general/steps/styles";
import {CreateSessionCoverImagesUploadStep} from "../cover-images-upload";
import {CreateSessionAutomationsStep} from "../automations";
import {DraftResumeBanner} from "../../../../../components/offering-form/general/draft-resume-banner";
import {useDraftResumeBanner} from "../../../../../utils/offering-create-draft";

export function CreateSessionMultiStepForm() {
  const {
    dispatch,
    wasDraftRestored,
    state: {currentCreateSessionStep},
  } = useCreateSessionContext();
  const {formKey, showBanner, handleStartFresh} = useDraftResumeBanner(
    wasDraftRestored,
    dispatch
  );

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {showBanner ? <DraftResumeBanner onStartFresh={handleStartFresh} /> : null}
      <StyledHideStepOnDesktop>
        <CreateSessionFormStepsMobile />
      </StyledHideStepOnDesktop>
      <ServiceFormLayout key={formKey}>
        {currentCreateSessionStep === "basicForm" ? (
          <CreateSessionBasicFormStep />
        ) : currentCreateSessionStep === "checkoutForm" ? (
          <CreateSessionCheckoutFormStep />
        ) : currentCreateSessionStep === "coverImagesUpload" ? (
          <CreateSessionCoverImagesUploadStep />
        ) : currentCreateSessionStep === "automations" ? (
          <CreateSessionAutomationsStep />
        ) : null}
      </ServiceFormLayout>
    </Space>
  );
}
